import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { UserService } from 'app/Shared/Services/user.service';
import { OdrReportsService } from '../odr-reports.service';
import { CommonValidators } from 'app/Shared/Constant/common-validators';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DrawerModule } from 'primeng/drawer';
import { ToastModule } from 'primeng/toast';
import { Select } from 'primeng/select';
import { DatePickerModule } from 'primeng/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { format } from 'date-fns';
import { HttpErrorResponse } from '@angular/common/http';
import { combineLatest, map } from 'rxjs';
import { MessageService } from 'primeng/api';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';


@Component({
  selector: 'app-add-edit-view-odr-reports',
  imports: [DialogModule,CommonModule, ButtonModule, FormsModule,Select,DatePickerModule,MatChipsModule,
          MatProgressSpinnerModule, MatTooltipModule, ConfirmDialogModule, DrawerModule, ToastModule, ReactiveFormsModule],
  templateUrl: './add-edit-view-odr-reports.html',
  styleUrl: './add-edit-view-odr-reports.scss',
})
export class AddEditViewOdrReports {

@Input() showDialog: boolean = false;
@Output() visibilityChange = new EventEmitter<boolean>();
@Input('isDisplayCommentViewer') isDisplayCommentViewer: boolean = false;
@Input('isApprove') isApprove: boolean = false;
@Input('isDecline') isDecline: boolean = false;
@Input('selectedRow') selectedRow: any = [];
@Input('selectedRowIndex') selectedRowIndex:any;
@Input ('comment') comment:any
commentStatement: any;
maxCharsLength: number = 256;
commentStaticFilters:any;


reportForm!:FormGroup
  typeOptions=[
    {label: '606(A1)' , value:'606(A1)'},
    {label: '606(B1)' , value:'606(B1)'},
    {label: '606(B3)' , value:'606(B3)'},
    {label: '606 Interchange' , value:'606 Interchange'}]
    
    reportingQuarter=[
    {label: '1' , value:'1'},
    {label: '2' , value:'2'},
    {label: '3' , value:'3'},
    {label: '4' , value:'4'}]

    useComplianceIdOptions=[
    {label: 'True' , value:true},
    {label: 'False' , value:false}]
    
  selectedType:any;
  header: any = "Generate Report";
  subscription: any;
  showCustomerDropdown:boolean=false;
  customerList:any[]=[];
  senderImidList:any[]=[];
  isSubmitButtonDisabled : boolean = false;
  isOdrReportLoadingResults : boolean = false;
  private lastLoadedStartDate: Date | null = null;
  private lastLoadedEndDate: Date | null = null;


   constructor(public userService: UserService,
    private sharedHttpClientService: SharedHttpClientService,
          public odrReportsService:OdrReportsService,
          private messageService: MessageService,
          private urlsService: UrlsService,
          private fb:FormBuilder) {}

  ngOnInit(): void {
     this.reportForm = this.fb.group({
      type:[null, Validators.required],
      quarter:[null],
      reportingYear:[null],
      startDate:[null],
      endDate:[null],
      customerName:[null],
      senderImid:[null],
      useComplianceId:[true],
    });
    this.handleReportChangeValidation()
    this.commentStaticFilters = this.selectedRow;
    this.commentStatement = this.comment;

      this.reportForm.get('type')!.valueChanges.subscribe((type: string) => {
        const isB606 = type === '606(B1)' || type === '606(B3)' || type === '606 Interchange';
        if (isB606) {
          this.showCustomerDropdown = true;
          const today = new Date();
          const threeMonthsAgo = new Date();
          threeMonthsAgo.setMonth(today.getMonth() - 3);
          this.loadDropdownList(type, threeMonthsAgo, today);
        } else {
          this.showCustomerDropdown = false;
          this.lastLoadedStartDate = null;
          this.lastLoadedEndDate = null;
        }
      });

      combineLatest([
        this.reportForm.get('startDate')!.valueChanges,
        this.reportForm.get('endDate')!.valueChanges
      ]).subscribe(([startDate, endDate]: [any, any]) => {
        const type: string = this.reportForm.get('type')?.value;
        const isB606 = type === '606(B1)' || type === '606(B3)' || type === '606 Interchange';
        if (!isB606 || !startDate || !endDate || !this.lastLoadedStartDate || !this.lastLoadedEndDate)
          return;
        const isWithinDefaultRange = new Date(startDate) >= this.lastLoadedStartDate && new Date(endDate) <= this.lastLoadedEndDate;
        if (!isWithinDefaultRange) {
          this.loadDropdownList(type, startDate, endDate);
        }
      });
    this.isSubmitButtonDisabled = false;

  }
  handleReportChangeValidation(){
    this.reportForm.get('type')?.valueChanges.subscribe(type=>{

      let quarter = this.reportForm.get('quarter');
      let reportingYear= this.reportForm.get('reportingYear');
      let startDate= this.reportForm.get('startDate');
      let endDate= this.reportForm.get('endDate');
      let customerName= this.reportForm.get('customerName');
      let senderImid= this.reportForm.get('senderImid');
      let useComplianceId= this.reportForm.get('useComplianceId');

      [quarter,reportingYear,startDate,endDate,customerName,senderImid].forEach(ctrl=>{
        ctrl?.clearValidators();
        ctrl?.reset();
      });
      useComplianceId?.reset(true);

       this.reportForm.clearValidators();

      if(type == '606(A1)'){
        quarter?.setValidators([Validators.required]);
        reportingYear?.setValidators([Validators.required,CommonValidators.year()])
      }
      else if(type == '606(B1)' || type == '606(B3)'){
        startDate?.setValidators([Validators.required,CommonValidators.noFutureDate()]);
        endDate?.setValidators([Validators.required]);
        customerName?.setValidators([Validators.required]);

        this.reportForm.setValidators(CommonValidators.dateRangeValidator());
      }
      else if(type == '606 Interchange'){
        startDate?.setValidators([Validators.required,CommonValidators.noFutureDate()]);
        endDate?.setValidators([Validators.required]);
        senderImid?.setValidators([Validators.required]);

        this.reportForm.setValidators(CommonValidators.dateRangeValidator());
      }

      [quarter, reportingYear, startDate, endDate, customerName, senderImid].forEach(ctrl => {
        ctrl?.updateValueAndValidity();
      });
      this.reportForm.updateValueAndValidity();

    });
  }

  getErrorMessage(controlName:string){
  const control = this.reportForm.get(controlName);
  if(!control || !control.errors || !control.touched){
    return '';
  }
   if(control.errors['required']){
    const message:any ={
      type : 'Report type is required',
      quarter:'Reporting quarter is required',
      reportingYear:'Reporting year is required',
      startDate:'Reporting start date is required',
      endDate:'Reporting end date is required',
      customerName:'Customer Name is required',
      senderImid:'Sender IMID is required'
    };
    return message[controlName];
   } 
   if(controlName === 'reportingYear'){

    if (control.errors['notNumeric']) {
      return `Reporting year invalid input`;
    } 
    if (control.errors['invalidYearLength']) {
      return `Reporting year length should be 4`;
    }
    if (control.errors['yearTooLow'] || control.errors['yearTooHigh'] ) {
      return `Reporting year invalid year range`;
    }  

   }
   if(controlName === 'startDate'){

    if (control.errors['futureDate']) {
      return `Reporting start date cannot be a future date`;
    }
    
   }
   return '';
  }
  private loadDropdownList(type: string, startDate: any, endDate: any) {
    this.lastLoadedStartDate = new Date(startDate);
    this.lastLoadedEndDate = new Date(endDate);
    if (type === '606 Interchange') {
      this.getSenderIMIDList(startDate, endDate);
    } else {
      this.getCustomerList(startDate, endDate);
    }
  }

  getCustomerList(startDate: string, endDate:string){
    let payload = {
        "mpid": this.userService.getActiveMPID(),
        "reportingStartDate": startDate,
        "reportingEndDate": endDate
    }

    this.odrReportsService.isLoadingResults = true;

      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_Reports_Customer_List), payload)
          .pipe(map((response: Response) => {
              return response;
            })).subscribe({
              next: (response: any) => {
                this.odrReportsService.isLoadingResults = false;
                this.customerList = response.Data;
              },        
              error: (err: HttpErrorResponse) => {
                this.odrReportsService.isLoadingResults = false;
              }
        });  
  }

  getSenderIMIDList(startDate: string, endDate:string){
    let payload = {
        "mpid": this.userService.getActiveMPID(),
        "reportingStartDate": startDate,
        "reportingEndDate": endDate
    }

    this.odrReportsService.isLoadingResults = true;

      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_Reports_Sender_IMID_LIST), payload)
          .pipe(map((response: Response) => {
              return response;
            })).subscribe({
              next: (response: any) => {
                this.odrReportsService.isLoadingResults = false;
                this.senderImidList = response.Data;
              },        
              error: (err: HttpErrorResponse) => {
                this.odrReportsService.isLoadingResults = false;
              }
        });  
  }
  onSubmit() {
    if (this.reportForm.invalid) {
      this.reportForm.markAllAsTouched();
      return;
    }
    const typeVal = this.reportForm.value['type'];
    let reportType = typeVal == '606(A1)' ? '606a1' : typeVal == '606(B1)' ? '606b1' : typeVal == '606(B3)' ? '606b3' : typeVal == '606 Interchange' ? '606ic' : '';
    let payLoad = {
      "mpid": this.userService.getActiveMPID(),
      "reportType": reportType,
      "year": this.reportForm.value['reportingYear'],
      "quarter": this.reportForm.value['quarter'],
      "reportingStartDate": format(this.reportForm.value['startDate'], 'yyyyMMdd'),
      "reportingEndDate": format(this.reportForm.value['endDate'],'yyyyMMdd'),
      "customerName": this.reportForm.value['customerName'],
      "senderImid": this.reportForm.value['senderImid'],
      "useComplianceId": this.reportForm.value['useComplianceId'],
      "user": this.userService.getUserName()
    }
    /* Catch User Action Log */
            this.userService.logUserActivity("Generate - ODR 606 Report", null, {
              'Text1': this.userService.userFirstName + ' Generate ODR 606 Report',
              'Text2': 'User Filter Parameters: ' + JSON.stringify(payLoad)
            });
    this.isSubmitButtonDisabled = true;
    this.isOdrReportLoadingResults = true;

    this.odrReportsService.getGenrateReport(payLoad)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (data: any) => {
          this.isOdrReportLoadingResults = false;
          if (data.status) {
            this.odrReportsService.reloadData();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Report generation started successfully'
            });
            /* Catch User Action Log */
            this.userService.logUserActivity("Generate - ODR 606 Report", null, {
              'Text1': this.userService.userFirstName + ' Generated ODR 606 Report',
              'Text2': 'User Filter Parameters: ' + JSON.stringify(payLoad)
            });
            this.onclose();
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: data.Data
            });
          }

          this.isSubmitButtonDisabled = false;
          this.isOdrReportLoadingResults = false;
        },
        error: (err: HttpErrorResponse) => {
          this.isOdrReportLoadingResults = false;
          this.isSubmitButtonDisabled = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
          });
        }
      });
  }

  onclose() {
    this.visibilityChange.emit(false);
    this.showCustomerDropdown = false;
    this.commentStatement = this.comment;
    this.selectedRow =[];
    if (this.reportForm) {
      this.reportForm.reset();
    }
  }
  getResolutionWidth() {
    return window.innerWidth - 500 + 'px';
  }
  insertComment() {
    if(this.commentStatement){
    let payload;
    const formattedDate = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss");
    const userName = this.userService.getUserName();
    if (this.isApprove) {
      payload = {
         ...this.commentStaticFilters,
        reportStatus: "APPROVED",
        comments: this.commentStatement,
        approvedBy: userName,
        approvedDate: formattedDate,
      }
    }
    else {
      payload = {
        ...this.commentStaticFilters,
        reportStatus: "DECLINED",
        comments: this.commentStatement,
        declinedBy: userName,
        declinedDate: formattedDate
      };
    }

    /* Catch User Action Log */
    this.userService.logUserActivity("Add Comment - ODR 606 Report", null, {
      'Text1': this.userService.userFirstName + ' added comment',
      'Text2': 'User Filter Parameters: ' + JSON.stringify(payload)
    });

    this.isOdrReportLoadingResults = true;


    this.odrReportsService.getEdit(payload)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (data: any) => {
          this.isOdrReportLoadingResults = false;

          if (data.status) {
            this.odrReportsService.reloadData();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Record updated successfully'
            });
            this.onclose();
            this.odrReportsService.reloadData();
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: data.Data
            });
          }
        },
        error: (err: HttpErrorResponse) => {
          this.isOdrReportLoadingResults = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.message
          });
        }
      });
    }
  }
}
